export default __webpack_public_path__ + "static/image-002-3d85f94623f53055755655c5d6937e9b.png";